import { getAlexUrl } from './getAlexUrl';

/**
 * UTM-tagged "Explore with ALEX" URL for the LMS field-note teaser (ADM-1498).
 *
 * Mirrors the per-channel links generated server-side (FieldNoteExploreUrl):
 * utm_source=field_note marks the field-note origin in GA4, utm_medium carries
 * the channel (here: the LMS), utm_content the note's publication date.
 */
export const buildExploreUrl = (publicationDate) => {
  const params = new URLSearchParams({
    fn: publicationDate,
    utm_source: 'field_note',
    utm_medium: 'lms',
    utm_campaign: 'field-notes',
    utm_content: publicationDate
  });
  return `${getAlexUrl()}/explore?${params.toString()}`;
};

export default buildExploreUrl;
